// dilimKontrolu.js — ELLE EKLENEN MEYDANIN SAAT DİLİMİ: BUL + YAZ/KIŞ GEÇİŞLERİNİ GÖSTER (30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl): *"Elle eklenen meydanda koordinat girilecek, oradan saat dilimi çıkacak"* ·
//    DST kararı *"a"*: otomatik + kontrol — dilim koordinattan bulunur, o yılın yaz/kış geçişleri
//    GÖSTERİLİR, GO2 resmi kaynakla karşılaştırıp onaylar.
// Dilim: open-meteo `timezone=auto` (30 Eyl'de denendi: LTFE Europe/Istanbul · LSGG Europe/Zurich ·
//    KPHX America/Phoenix · Winnipeg America/Winnipeg · Ceuta Africa/Ceuta — sınır vakaları doğru).
// Geçişler: FTL motorunun KENDİ `tzOffsetMin`i ile — ikinci bir saat hesabı yazılmaz (tek kaynak);
//    ekranda görülen, FTL'nin o meydanda kullanacağı farkın ta kendisidir.
import { tzOffsetMin } from './FTLEngine';
import { utcGunAySaat } from '../utcTarih';

/** open-meteo'dan IANA dilim adı. Dönüş: { tz, hata } — hata yutulmaz. */
export async function koordinattanDilim(lat, lon, fetchFn = (typeof fetch !== 'undefined' ? fetch : null)) {
  if (!fetchFn) return { tz: null, hata: 'no network access' };
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&timezone=auto&current=temperature_2m`;
  try {
    const r = await fetchFn(url);
    if (!r.ok) return { tz: null, hata: `time zone service answered ${r.status}` };
    const d = await r.json();
    const tz = typeof d?.timezone === 'string' ? d.timezone : '';
    // "GMT" / boş: servis dilimi bulamadı demektir — uydurulmaz.
    if (!/^[A-Za-z_]+\/[A-Za-z0-9_+\-/]+$/.test(tz)) return { tz: null, hata: `no time zone returned for these coordinates (${tz || 'empty'})` };
    // Tarayıcının dilim verisi bu adı tanımıyorsa FTL de hesaplayamaz — kaydettirilmez.
    try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); }
    catch { return { tz: null, hata: `time zone ${tz} is not known to this browser` }; }
    return { tz, hata: null };
  } catch (e) {
    return { tz: null, hata: `time zone service not reachable (${e?.message || e})` };
  }
}

/** UTC FARKININ TEK YAZIMI (21 Eki 2026, K8 — Serkan onayı): "UTC+03:00", "UTC-07:00", "UTC+05:30", "UTC+05:45".
 *  🔴 Önce iki biçim vardı: AIRPORTS "UTC+3" / "UTC+5:30", COMPANY PROFILE "UTC+03:00" — aynı süper admin ekranında. Saat ve
 *  dakika hep iki hane: yarım ve çeyrek saatli dilimler aynı hizada okunur. */
export function utcFarkMetni(dk) {
  const isaret = dk < 0 ? '-' : '+';
  const m = Math.abs(dk);
  return `UTC${isaret}${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
}
/** Dilimin verilen andaki (varsayılan: şimdi) farkı. Yaz saati uygulayan dilimde fark mevsime göre değişir.
 *  🔴 AN DAKİKAYA KIRPILIR — yoksa fark 45 saniye EKSİK çıkar: `tzOffsetMin` dilimin DAKİKA çözünürlüklü duvar saatinden
 *  MİLİSANİYE çözünürlüklü anı çıkarır; ham `Date.now()` ile Türkiye `+02:59`, Katmandu `+05:44` yazdı (ölçüldü — eskiden
 *  COMPANY PROFILE'ın kendi fonksiyonundaydı). Dilim çözülemezse adı döner. */
export function dilimFarkMetni(tz, an = Date.now()) {
  const dakikaBasi = Math.floor(an / 60000) * 60000;
  const dk = Math.round(tzOffsetMin(tz, dakikaBasi));
  return Number.isFinite(dk) ? utcFarkMetni(dk) : tz;
}

// 🔴 30 Eyl 2026 (ölçüldü): ilk hâli yılı SAAT SAAT tarıyordu — iki yıl ≈ 17.500 hesap, bir ekran çizimi 562 ms.
//    Gün gün taramaya indi (32 ms); ama meydan LİSTESİNDE 50 farklı dilimli bir arama yine 610 ms sürdü (ölçüldü).
//    Artık HAFTA HAFTA tarar, geçişi o hafta içinde dakikasına kadar ikiye bölerek bulur (sonuç aynı) ve aynı
//    dilim + yıl için sonucu SAKLAR. Bir hafta içinde iki kez saat değiştiren dilim yoktur (en kısa aralık Fas'ın
//    Ramazan dönemi, ~1 ay). FTL motoruna (`tzOffsetMin`) dokunulmadı — o, hesabın tek kaynağı olarak kalır.
const HAFTA = 7 * 86400000;
const onbellek = new Map();

/** Yılın geçişleri: [{ an (ms, UTC), once (dk), sonra (dk) }] — haftalık tarar, dakikaya iner. */
export function dstGecisleri(tz, yil) {
  const anahtar = `${tz}|${yil}`;
  if (onbellek.has(anahtar)) return onbellek.get(anahtar);
  const bas = Date.UTC(yil, 0, 1), son = Date.UTC(yil + 1, 0, 1);
  const out = [];
  let onceki = tzOffsetMin(tz, bas);
  let oncekiAn = bas;
  for (let t = Math.min(bas + HAFTA, son); ; t = Math.min(t + HAFTA, son)) {
    const o = tzOffsetMin(tz, t);
    if (o !== onceki) {
      let a = oncekiAn, b = t;                       // a: eski fark, b: yeni fark
      while (b - a > 60000) {
        const m = a + Math.floor((b - a) / 120000) * 60000;
        if (tzOffsetMin(tz, m) === onceki) a = m; else b = m;
      }
      out.push({ an: b, once: onceki, sonra: o });
      onceki = o;
    }
    oncekiAn = t;
    if (t >= son) break;
  }
  onbellek.set(anahtar, out);
  return out;
}

/** Ekrandaki cümle: "29 MAR, 01:00Z UTC+1 → UTC+2 · 25 OCT, 01:00Z UTC+2 → UTC+1" ya da "no summer time — UTC+3 all year". */
export function dstMetni(tz, yil) {
  const g = dstGecisleri(tz, yil);
  if (!g.length) return `no summer time in ${yil} — ${utcFarkMetni(tzOffsetMin(tz, Date.UTC(yil, 0, 1)))} all year`;
  return g.map(x => `${utcGunAySaat(x.an, { z: true })} ${utcFarkMetni(x.once)} → ${utcFarkMetni(x.sonra)}`).join(' · ');
}
